/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProductionReference
 */
export interface ProductionReference {
    /**
     * 
     * @type {number}
     * @memberof ProductionReference
     */
    id: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionReference
     */
    readonly isSpecial?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductionReference
     */
    readonly specialType?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionReference
     */
    readonly totalSize?: number | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionReference
     */
    readonly name?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionReference
     */
    readonly obscureName?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProductionReference
     */
    readonly description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ProductionReference
     */
    readonly longDescription?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProductionReference
     */
    readonly active?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ProductionReference
     */
    readonly template?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ProductionReference
     */
    readonly defaultGroup?: number | null;
}

export function ProductionReferenceFromJSON(json: any): ProductionReference {
    return ProductionReferenceFromJSONTyped(json, false);
}

export function ProductionReferenceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProductionReference {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'isSpecial': !exists(json, 'is_special') ? undefined : json['is_special'],
        'specialType': !exists(json, 'special_type') ? undefined : json['special_type'],
        'totalSize': !exists(json, 'total_size') ? undefined : json['total_size'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'obscureName': !exists(json, 'obscure_name') ? undefined : json['obscure_name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'longDescription': !exists(json, 'long_description') ? undefined : json['long_description'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'template': !exists(json, 'template') ? undefined : json['template'],
        'defaultGroup': !exists(json, 'default_group') ? undefined : json['default_group'],
    };
}

export function ProductionReferenceToJSON(value?: ProductionReference | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}


